// Projects — the atomic unit of Lenovo India CSR's funding to implementation partners.
// Each partner may have 1+ projects. A project has its own status, score, and lifecycle.

import { PARTNERS } from "./partners";

export const GRANTS = [
  // ── STEM Education ────────────────────────────────────────────
  { id: "LEN-P-001", name: "Lab-on-a-Tab Mobile Science",      partnerId: "agastya",     beneficiaries: 4800, fundedCr: 2.0, since: 2023, status: "Active", score: 4.6 },
  { id: "LEN-P-002", name: "Young Instructor Programme",        partnerId: "agastya",     beneficiaries: 3400, fundedCr: 1.6, since: 2021, status: "Active", score: 4.2 },
  { id: "LEN-P-003", name: "STEM Teacher Enablement",           partnerId: "meghshala",   beneficiaries: 2600, fundedCr: 1.3, since: 2022, status: "Active", score: 4.0 },
  { id: "LEN-P-004", name: "Vernacular Content Studio",         partnerId: "meghshala",   beneficiaries: 1500, fundedCr: 0.9, since: 2023, status: "Active", score: 3.6 },

  // ── Digital Literacy ──────────────────────────────────────────
  { id: "LEN-P-005", name: "Innovators of Tomorrow",            partnerId: "muskaan",     beneficiaries: 3600, fundedCr: 2.0, since: 2025, status: "Active", score: 4.5 },
  { id: "LEN-P-006", name: "Tablet Learning Model",             partnerId: "yuva",        beneficiaries: 2800, fundedCr: 1.6, since: 2024, status: "Active", score: 2.9 },
  { id: "LEN-P-007", name: "SmarterEd Online Platform",         partnerId: "evidyaloka",  beneficiaries: 3200, fundedCr: 1.5, since: 2022, status: "Active", score: 4.4 },
  { id: "LEN-P-008", name: "Digital Classrooms — Rural",        partnerId: "evidyaloka",  beneficiaries: 2000, fundedCr: 0.9, since: 2023, status: "Active", score: 3.8 },

  // ── Employability & Skilling ──────────────────────────────────
  { id: "LEN-P-009", name: "Skills for Young Women",            partnerId: "technoserve", beneficiaries: 1900, fundedCr: 1.8, since: 2023, status: "Active", score: 4.3 },
  { id: "LEN-P-010", name: "Campus to Corporate Careers",       partnerId: "tns",         beneficiaries: 1200, fundedCr: 1.3, since: 2023, status: "Active", score: 4.2 },
  { id: "LEN-P-011", name: "IT-ITES Skilling Track",            partnerId: "edubridge",   beneficiaries: 2100, fundedCr: 1.6, since: 2022, status: "Active", score: 3.9 },
  { id: "LEN-P-012", name: "Women in Tech Bridge",              partnerId: "edubridge",   beneficiaries: 1300, fundedCr: 1.0, since: 2024, status: "Active", score: 3.5 },

  // ── Sustainability ────────────────────────────────────────────
  { id: "LEN-P-013", name: "Work for Humankind — Millet Revival", partnerId: "dreamindia", beneficiaries: 1400, fundedCr: 1.5, since: 2023, status: "Active", score: 4.1 },
  { id: "LEN-P-014", name: "E-Waste Circularity Drive",         partnerId: "saahas",      beneficiaries: 820,  fundedCr: 1.9, since: 2022, status: "Active", score: 3.0, ewasteTonnes: 1450 },
  { id: "LEN-P-015", name: "Green Campus Plantation",           partnerId: "sankalptaru", beneficiaries: 0,    fundedCr: 1.7, since: 2022, status: "Active", score: 4.5, trees: 185000 },
];

// ── Helpers ──────────────────────────────────────────────────────
const partnerLookup = PARTNERS.reduce((acc, p) => { acc[p.id] = p; return acc; }, {});

// Deterministic 32-bit FNV-1a hash so disbursement / utilisation values are stable
function hash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0);
}

export function enrichGrant(g) {
  const p = partnerLookup[g.partnerId];

  const h1 = hash(g.id + ":disb");
  const h2 = hash(g.id + ":util");
  const isClosed = g.status === "Closed";
  const disbursePct = isClosed ? 92 + (h1 % 9) : 55 + (h1 % 41);
  const utilisePct  = isClosed ? 94 + (h2 % 7)  : 70 + (h2 % 29);

  const disbursedCr = +(g.fundedCr * (disbursePct / 100)).toFixed(2);
  const utilisedCr  = +(disbursedCr * (utilisePct / 100)).toFixed(2);

  return {
    ...g,
    partnerName: p?.name || "—",
    pillar: p?.pillar,
    states: p?.states || [],
    disbursedCr,
    utilisedCr,
    disbursePct,
    utilisePct,
  };
}

export function grantsForPillar(pillarId) {
  return GRANTS.map(enrichGrant).filter((g) => g.pillar === pillarId);
}

// RAG mapping for grant score (out of 5)
export function ragForScore(score) {
  if (score >= 4)   return { label: "Green", bg: "bg-emerald-50", text: "text-emerald-700", dot: "#10B981", border: "border-emerald-200" };
  if (score >= 3)   return { label: "Amber", bg: "bg-amber-50",   text: "text-amber-700",   dot: "#F59E0B", border: "border-amber-200" };
  return                  { label: "Red",   bg: "bg-red-50",     text: "text-red-700",     dot: "#EF4444", border: "border-red-200" };
}
